import type { QueryClient } from "@tanstack/react-query";

import { actionAlertsQueryKey, invalidateActionAlerts } from "@/hooks/useActionAlerts";

export function grantOpportunitiesQueryKey(
  municipalityId: number | undefined,
  filter?: string,
) {
  return filter
    ? (["grant_opportunities", municipalityId, filter] as const)
    : (["grant_opportunities", municipalityId] as const);
}

export function grantOpportunityEventsQueryKey(
  municipalityId: number | undefined,
  opportunityId: number,
) {
  return ["grant_opportunity_events", municipalityId, opportunityId] as const;
}

// Omit opportunityId to sweep every opportunity's feed in the team: some
// writes (adding an external person, queueing an invite, a bulk edit) record
// events on more than the opportunity in view.
export function invalidateGrantOpportunityEvents(
  queryClient: QueryClient,
  municipalityId: number | undefined,
  opportunityId?: number,
) {
  if (!municipalityId) return;
  queryClient.invalidateQueries({
    queryKey:
      opportunityId === undefined
        ? (["grant_opportunity_events", municipalityId] as const)
        : grantOpportunityEventsQueryKey(municipalityId, opportunityId),
  });
}

export function invalidateGrantSuitePipeline(
  queryClient: QueryClient,
  municipalityId: number | undefined,
) {
  if (!municipalityId) return;
  queryClient.invalidateQueries({ queryKey: ["grant_opportunities", municipalityId] });
  invalidateActionAlerts(queryClient, municipalityId);
}

export { actionAlertsQueryKey };
